import { gql } from '@apollo/client';

export const FETCH_ALLEGATI = gql`
  query fetchAllegati(
    $where: AllegatiWhereInput
    $order: [AllegatiOrder!]
    $first: Int
  ) {
    allegatis(where: $where, order: $order, first: $first) {
      edges {
        node {
          objectId
          createdAt
          updatedAt
          nome
          mimeType
          size_bytes
          isBackgroundFusion
          backgroundFusionRawBackground
          backgroundFusionRawSubject
          backgroundFusionComposite
          allegato {
            url
            name
          }
          defunto_pointer {
            objectId
          }
          editor_canvas_pointer {
            objectId
          }
        }
      }
      count
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const FETCH_ALLEGATI_WITH_AI_FIELDS = gql`
  query fetchAllegatiWithAiFields(
    $where: AllegatiWhereInput
    $order: [AllegatiOrder!]
    $first: Int
  ) {
    allegatis(where: $where, order: $order, first: $first) {
      edges {
        node {
          objectId
          createdAt
          updatedAt
          nome
          mimeType
          size_bytes
          isAiEdit
          aiEditPrompt
          aiEditRawImage
          isRemovebg
          removebgRawImage
          isBlurBg
          isMagicEraser
          magicEraserRawImage
          isChangeClothes
          changeClothesRawImage
          isSmile
          smileRawImage
          isColorizeBw
          colorizeBwRawImage
          isExpand
          expandRawImage
          isImageEnhancement
          enhancementRawImage
          isBackgroundFusion
          backgroundFusionRawBackground
          backgroundFusionRawSubject
          backgroundFusionComposite
          rawImage
          allegato {
            url
            name
          }
          defunto_pointer {
            objectId
          }
          editor_canvas_pointer {
            objectId
          }
        }
      }
      count
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
